import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import carpet1 from '../../assets/images/Offer/Office-1.jpg'
import carpet11 from '../../assets/images/Offer/Office-1.jpg'
import carpet2 from '../../assets/images/Offer/Office-2.jpg'
import carpet22 from '../../assets/images/Offer/Office-2.jpg'
import { Link } from "react-router-dom";

const products = [
  {
    id: 1,
    title: "Bath Linen",
    // price: "$39.01",
    primaryImage: carpet1,
    hoverImage: carpet11,
    review: 3,
    swatches: ["black", "maroon"],
     url: "/bathline",
  },
  {
    id: 2,
    title: "Bath Mat",
    // price: "$299.01",
    primaryImage: carpet2,
    hoverImage: carpet22,
    review: 4,
    swatches: ["gray", "red", "orange", "yellow"],
    url: "/bathline",
  },

];

function Offer() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
  
      <> 
      <div className="section product-slider" style={{ background: "#dec7a885", marginBottom: "10px"}}>
     <div className="container"> 
        <div className="section-header">
                 <h2> Exclusive  Offers </h2> 
                 <p> Designed to refresh Your everyday Life </p>
              </div>
      <Slider {...settings} className="productSlider grid-products">
        {products.map((product) => (
          <div key={product.id} className="col-12 item">
            <div className="product-image" style={{position:'relative' }}>
             <Link to={product.url} className="product-img">
                <img
                  className="primary"
                  src={product.primaryImage}
                  alt={product.title}
                />
                <img
                  className="hover"
                  src={product.hoverImage}
                  alt={`${product.title} hover`}
                />
              </Link>
              <div className="product-details text-center" style={{ position: 'absolute', bottom: '10px', left:"15px", backgroundColor: 'rgb(0 0 0 / 45%)', padding: '5px 10px', borderRadius: '5px', fontSize: '14px', fontWeight: '400' }}>
              <div className="product-name">
                <Link to="product-layout1.html" style={{ color:"#FFF" }}>{product.title}</Link>
              </div>
            </div>
            </div>
          </div>
        ))}
      </Slider>
      </div>
    </div>
      
      
      </>
  
  );
}
export default Offer;
